<template>
  <div class="cutsom_container">
    <div class="row">
      <br />
      <div class="col m6">
        <back-container
          :link="'/patient/dots/edit/' + $route.params.id"
        ></back-container>
        <visit-date-detail
          @close="detailShow = false"
          v-bind:show="detailShow"
          v-bind:detailData="detailData"
        ></visit-date-detail>
        <date-edit-modal
          @close="dateEditShow = false"
          v-bind:show="dateEditShow"
          v-bind:detailData="detailData"
        ></date-edit-modal>
        <edit-dots-visit-data
          @close="editInfoModalShow = false"
          v-bind:show="editInfoModalShow"
          v-bind:detailData="detailData"
        ></edit-dots-visit-data>

        <router-link
          v-show="
            data.patient.finish != 1 &&
              data.patient.finish != 2 &&
              data.patient.dots_app_status == 1
          "
          style="margin-left:20px;"
          :to="'/dots/visitdate/create/' + $route.params.id"
          class="btn blue darken-3"
          >Create Visit Date</router-link
        >
      </div>
      <div class="col m6" v-if="data.patient.dots_app_status == 1">
        <dot-status></dot-status>
      </div>
    </div>
    <div class="row">
      <div class="col m6">
        <div class="card card-content">
          <table class="app-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>TB Code</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ data.patient.name }}</td>
                <td>{{ data.patient.tb_code }}</td>
                <td>{{ data.patient.phone }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <dots-visit-date-remark
            :patient="data.patient"
          ></dots-visit-date-remark>
        </div>
      </div>
      <div class="col m6">
        <div class="card card-content">
          <div class="row right">
            <router-link
              :to="'/dots/visitdate/all/' + $route.params.id"
              class="btn blue darken-3"
              >View All</router-link
            >
          </div>
          <table class="app-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Date</th>
                <th>Status</th>
                <th>Volunteer</th>
                <th>FO Edits</th>
                <th>Pill Count</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody v-if="!loading">
              <tr v-for="(item, index) in data.visit_dates" :key="item.id">
                <td>{{ index + 1 }}</td>
                <td>{{ item.date }}</td>
                <td>
                  {{ getStatus(item.status) }}
                </td>
                <td>
                  <span v-if="item.volunteer"
                    >{{ item.volunteer.code }} ({{ item.volunteer.name }})</span
                  >
                </td>
                <td>
                  <router-link
                    :to="'/patient/dots/edit-history/' + item.id"
                    class="blue-text darken-2"
                    >{{ item.edit_histories.length }}</router-link
                  >
                </td>
                <td>{{ item.status == 1 ? item.pill_count : "" }}</td>
                <td>
                  <button
                    @click="viewVisitDateDetail(item)"
                    class="btn blue darken-3"
                  >
                    <i class="material-icons">details</i>
                  </button>
                  <button
                    style="margin-left:10px;"
                    @click="editDate(item)"
                    class="btn blue darken-3"
                  >
                    <i class="material-icons">edit</i>
                  </button>
                  <button
                    style="margin-left:10px;"
                    @click="editVisitDate(item)"
                    class="btn green darken-3"
                  >
                    <i class="material-icons">edit brush</i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackContainer from "@/components/ReUse/BackContainer.vue";
import VisitDateDetail from "./VisitDateDetail.vue";
import DateEditModal from "./DateEditModal.vue";
import DOTStatus from "./DOTStatus.vue";
import DOTSVisitDateRemark from "./DOTSVisitDateRemark.vue";
import EditDotsVisitDate from "./EditDotsVisitDate.vue";
import { dayDiff } from "./../../../misc/visit_date_service";
export default {
  data() {
    return {
      detailShow: false,
      dateEditShow: false,
      editInfoModalShow: false,
      detailData: null,
    };
  },
  mounted() {
    this.$store.dispatch("getSideEffects");
    this.$store.dispatch("getDOTSVisitDate", {
      patient_id: this.$route.params.id,
      nowMonth: true,
    });
  },
  computed: {
    data() {
      return this.$store.getters.dots_visitdates;
    },
    loading() {
      return this.$store.getters.dots_visitdates_loading;
    },
    action_loading() {
      return this.$store.getters.dots_visitdates_action_loading;
    },
    action_finish() {
      return this.$store.getters.dots_visitdates_action_finish;
    },
  },
  methods: {
    deleteData(id) {
      this.$store.dispatch("deleteDOTSVisitDate", {
        id: id,
      });
    },
    getStatus(id) {
      switch (parseInt(id)) {
        case 1:
          return "Visited";
          break;
        case 2:
          return "Cannot Connect";
          break;
        case 0:
          return "Pending";
          break;
      }
    },
    viewVisitDateDetail(data) {
      this.detailShow = true;
      this.detailData = data;
    },
    editDate(data) {
      this.dateEditShow = true;
      this.detailData = data;
    },
    editVisitDate(data) {
      this.detailData = data;
      this.editInfoModalShow = true;
    },
    canEditData(data) {
      if (dayDiff(new Date(data.date), new Date()) < 31) return true;
      else return false;
    },
  },
  watch: {
    action_finish(val) {
      if (val) {
        this.$notify({
          group: "noti",
          type: "success",
          text: "Deleted",
        });
      }
    },
  },
  components: {
    "back-container": BackContainer,
    "visit-date-detail": VisitDateDetail,
    "date-edit-modal": DateEditModal,
    "dot-status": DOTStatus,
    "edit-dots-visit-data": EditDotsVisitDate,
    "dots-visit-date-remark": DOTSVisitDateRemark,
  },
};
</script>

<style lang="scss" scoped>
.cutsom_container {
  padding-left: 35px;
  padding-right: 35px;
}
</style>
